'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _package = { version: '3.4.1' };

exports['default'] = _package.version;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/version/index.js
// module id = 409
// module chunks = 35783957827783 76758144387212 112643250470497